import { render, staticRenderFns } from "./BookInfinite.vue?vue&type=template&id=5a893d31"
import script from "./BookInfinite.vue?vue&type=script&lang=js"
export * from "./BookInfinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports